import React, { useContext } from "react";
import { GameService } from "../services/game-service";

const GameServiceContext = React.createContext<GameService>(null);
GameServiceContext.displayName = "GameService";

export default GameServiceContext;
export const useGameServiceContext = () => useContext(GameServiceContext);
